import React from 'react';
import { useTranslation } from 'react-i18next';
import Moment from 'moment';

import { FormDataText } from '../../../../styles/sharedUIElemStyles';

export interface Props {
  /** obiekt definujący daną i jej kategorię */
  value: {
    /** kategoria danej */
    dataIndex: string;
    /** timestamp */
    data: number;
  };
}
/**
 * Komponent przekształcający czas w formę czytelną dla użytkownika
 *
 */
export default function Hour({ value }: Props): JSX.Element {
  const { t } = useTranslation();

  return <FormDataText>{value && value.data ? Moment(value.data, 'x').format('L') : t('DATE_NOT_AVAILABLE')}</FormDataText>;
}
